/* GONE(2026-09-06): 売り切れが分かった品を、ビルダーの選択肢から即座に外す。

   在庫チェック（購入手順を開いたとき等）で売り切れが見つかると、Worker が
   その商品ページURLを控える。ここではそれを読んで、読み込んだ在庫から取り除く。

   ・シートからの物理削除は従来どおりGASの巡回が行う（6時間おき・200件ずつ）。
     こちらは「見つかった瞬間から、ほかのお客様にも出さない」ための即時反映。
   ・通信できない・応答が壊れているときは何もしない（在庫を減らさない）。
     在庫が消えるより、売り切れが一時的に残るほうが害が小さい。

   本体（sections/pasotsuku-build-assistant.liquid）の loadParts から
   `await window.BN_DROP_GONE(parts)` の1行で呼ぶ。容量の都合で実体はこちらに置いている。 */
(function () {
  "use strict";
  var API = "https://pasotsuku-buyback.tomoyukitakemoto0721.workers.dev";
  var cache = null;

  function load() {
    if (cache) return cache;
    /* 2分きざみのキャッシュ避け。売り切れは早く反映したいので短め */
    cache = fetch(API + "/market/gone.json?_t=" + Math.floor(Date.now() / 120000))
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) { return (j && j.ok && Array.isArray(j.urls)) ? j.urls : []; })
      .catch(function () { return []; });
    return cache;
  }

  /* GUARD(2026-09-06): 構成を表示する前に、その構成のパーツが本当に買えるかを見る。
     売り切れていた商品ページURLの配列を返す（空なら全部買える）。
     ・見に行くのはドスパラの商品ページだけ（AmazonとRakutenは在庫APIが無い）
     ・失敗したときは空配列。確認できないことを理由に構成を止めない。 */
  window.BN_STOCK_GUARD = function (build) {
    var items = [];
    ["cpu", "mb", "mem", "gpu", "ssd", "psu", "case", "cooler"].forEach(function (k) {
      var p = build && build[k];
      if (p && p.url && /dospara\.co\.jp/.test(p.url)) items.push({ cat: k, url: p.url, price: p.price || 0 });
    });
    if (!items.length) return Promise.resolve([]);
    return fetch(API + "/stock/check", {
      method: "POST", headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items: items }),
    }).then(function (r) { return r.json(); })
      .then(function (j) {
        if (!j || !j.ok) return [];
        var gone = (j.items || []).filter(function (i) { return i.status === "gone"; });
        /* 次に読むときのために、控えも更新しておく */
        if (gone.length) cache = null;
        return gone.map(function (i) { return i.url; }).filter(Boolean);
      })
      .catch(function () { return []; });
  };

  window.BN_DROP_GONE = function (parts) {
    return load().then(function (urls) {
      if (!urls.length || !parts) return parts;
      var gone = {};
      for (var i = 0; i < urls.length; i++) gone[urls[i]] = 1;
      Object.keys(parts).forEach(function (k) {
        var list = parts[k];
        if (!list || !list.length) return;
        var kept = list.filter(function (p) { return !p.url || !gone[p.url]; });
        /* 消えすぎたときは触らない。売り切れ記録が壊れていても在庫が空にならないように。 */
        if (kept.length >= Math.max(3, Math.floor(list.length * 0.5))) parts[k] = kept;
      });
      return parts;
    }).catch(function () { return parts; });
  };
})();
